import React, { Component } from 'react';
import RouteComponent from '../../Route';
import level_one_admin_config from '../../../../utils/routes/config/level_one_admin_config';

/**
 * @inheritdoc
 */
class LevelOneAdminLayout extends Component {
    render() {
        return <RouteComponent routes={level_one_admin_config} />;
    }
}

export default LevelOneAdminLayout;
